/* eslint-disable no-useless-escape */
/* eslint-disable inclusive-language/use-inclusive-words */

export function showRemainingCharactersInfo(currentCharacters, maxCharacters, displayAtPercentage = 10) {
  if (!maxCharacters) {
    return false;
  }
  const charactersUsedPercent = 100 - currentCharacters * 100 / maxCharacters;
  return charactersUsedPercent <= displayAtPercentage;
}